import { render, staticRenderFns } from "./arrow.vue?vue&type=template&id=2101e2c2&"
import script from "./arrow.vue?vue&type=script&lang=ts&"
export * from "./arrow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports